import { useEffect, useRef } from "react";

export interface ExternalVideoPlayerProps {
  divEle?: string;
  jsScript?: string;
}

const ExternalVideoPlayer = (props: ExternalVideoPlayerProps) =>{  
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (props.divEle && props.jsScript && containerRef.current) {
        // Create a new element
        const div = document.createRange().createContextualFragment(props.divEle);
        const script = document.createRange().createContextualFragment(props.jsScript);
        // Append the new element to the container
        containerRef.current?.appendChild(div);
        containerRef.current?.appendChild(script);
    } else if (containerRef.current) {
      containerRef.current.innerHTML = ''; 
    }
    return () => {
      if (containerRef.current) {
        containerRef.current.innerHTML = ''; 
      }
    };

  }, [props.divEle, props.jsScript]);

  return <div ref={containerRef} className="skipFontFamily" style={{width: '100%', height: '100%'}} />;
}

export default ExternalVideoPlayer;